import { gql } from "@apollo/client";

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $email: String!
    $newPassword: String!
    $token: String!
  ) {
    resetPassword(
      data: { email: $email, newPassword: $newPassword, token: $token }
    ) {
      message
    }
  }
`;

export const FETCH_USER = gql`
  query Me {
    me {
      id
      name
      email
      organization {
        name
        id
        clientId
        logo
      }
      organizations {
        id
        isPrimary
        deleted
        organization {
          id
          name
          clientId
          logo
        }
      }
      isSuperAdmin
      emailVerified
      isCeaMember
      roles {
        role
        service {
          name
          id
        }
        permission
      }
      avatar
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
      message
    }
  }
`;

export const FETCH_USERS = gql`
  query Users($contains: String) {
    users(contains: $contains) {
      id
      name
      email
    }
  }
`;

export const GET_CEA_MEMBERS = gql`
  query GetCeaMembers($search: String) {
    getCeaMembers(where: { name: $search }) {
      nodes {
        id
        name
        email
      }
    }
  }
`;

export const GET_CLIENT_USERS = gql`
  query GetClientUsers($organizationId: ID, $service: [ID!]!) {
    getClientUsers(
      where: { service: $service, organizationId: $organizationId }
    ) {
      id
      name
      email
      avatar
      emailVerified
      isMiClient
      organization {
        id
        name
        clientId
      }
    }
  }
`;

export const ADD_CLIENT = gql`
  mutation AddClient(
    $email: String!
    $organizationId: ID!
    $service: ID!
    $setAsPrimary: Boolean
  ) {
    createClient(
      data: {
        email: $email
        organizationId: $organizationId
        service: $service
        setAsPrimary: $setAsPrimary
      }
    ) {
      id
      message
    }
  }
`;

export const REMOVE_CLIENT = gql`
  mutation RemoveClient(
    $clientId: ID!
    $serviceIds: [ID!]!
    $organizationId: ID!
  ) {
    removeClient(
      data: {
        clientId: $clientId
        serviceIds: $serviceIds
        organizationId: $organizationId
      }
    ) {
      id
      message
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation ResendConfirmationEmail($email: String!, $service: ID!) {
    resendConfirmationEmail(data: { email: $email, service: $service }) {
      id
      message
    }
  }
`;

export const O_AUTH_LOGIN = gql`
  mutation OAuthLogin($name: String!, $email: String!, $accessToken: ID!) {
    oAuthLogin(
      data: { name: $name, email: $email, accessToken: $accessToken }
    ) {
      token
      user {
        id
        name
        email
        organizations {
          id
          isPrimary
          deleted
          organization {
            id
            name
            clientId
            logo
          }
        }
        isSuperAdmin
        emailVerified
        isCeaMember
        roles {
          role
          service {
            name
            id
          }
          permission
        }
        avatar
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      message
    }
  }
`;
